import * as firebase from 'firebase/app'
import * as React from 'react'
import { NavLink, Route } from 'react-router-dom'

import Clients from 'components/Clients'
import Company from 'components/Company'
import Dashboard from 'components/Dashboard'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import { IAuthState } from 'containers/Auth'
import Importer from 'containers/Importer'
import Invoices from 'containers/Invoices'
import AuthContext, { IAuthContext } from 'context/AuthContext'
import { ICompany } from 'interfaces/ICompany'
import { PATHS } from 'paths'

const css = require('!!raw-loader!./Main.css').default

class Main extends React.Component<{
  loaded: IAuthState['loaded']
  company: IAuthState['company']
  companies: IAuthState['companies']
  user: IAuthState['user']
  setCompany: IAuthContext['setCompany']
}> {
  public logout = () => firebase.auth().signOut()

  public handleChangeCompany = (e: React.ChangeEvent<HTMLSelectElement>) =>
    this.props.setCompany && this.props.setCompany(e.currentTarget.value)

  public get company(): ICompany {
    if (!this.props.company) {
      return {} as ICompany
    }

    return this.props.companies[this.props.company] || {}
  }

  public get showCompanyPicker(): boolean {
    if (!this.props.companies) {
      return false
    }

    return Object.keys(this.props.companies).length >= 2
  }

  public get companies(): Array<{ id: string; name: string }> {
    if (!this.props.companies) {
      return []
    }

    return Object.keys(this.props.companies).map(k => ({
      id: k,
      name: this.props.companies[k].name,
    }))
  }

  public render() {
    const { props, company, showCompanyPicker, companies } = this

    if (!props.loaded) {
      return <Loader />
    }

    return (
      <React.Fragment>
        <style>{css}</style>
        <div id="top">
          {props.user && <div id="user">{props.user.email}</div>}
          {company.name}
        </div>
        <div id="side">
          <ul>
            {showCompanyPicker && (
              <li className="company-picker">
                <select
                  value={this.props.company || ''}
                  onChange={this.handleChangeCompany}
                >
                  <option disabled value="">
                    Välj företag
                  </option>
                  {companies.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </li>
            )}
            <li>
              <NavLink exact activeClassName="active" to={PATHS.root}>
                <Icon icon="start" />
                Dashboard
              </NavLink>
            </li>
            {this.props.company && (
              <>
                <li>
                  <NavLink activeClassName="active" to={PATHS.company.index}>
                    <Icon icon="company" />
                    Företag
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to={PATHS.clients.index}>
                    <Icon icon="clients" />
                    Kunder
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to={PATHS.invoices.index}>
                    <Icon icon="invoice" />
                    Fakturor
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink activeClassName="active" to={PATHS.importer.index}>
                    Importera
                  </NavLink>
                </li> */}
              </>
            )}
          </ul>
          <a id="logout" className="button generic" onClick={this.logout}>
            <span>Logga ut</span>
          </a>
        </div>
        <div id="content">
          <Route exact path={PATHS.root} component={Dashboard} />
          <Route path={PATHS.company.index} component={Company} />
          <Route path={PATHS.clients.index} component={Clients} />
          <Route path={PATHS.invoices.index} component={Invoices} />
          <Route path={PATHS.importer.index} component={Importer} />
        </div>
      </React.Fragment>
    )
  }
}

export default () => (
  <AuthContext.Consumer>
    {({ loaded, company, companies, user, setCompany }) => (
      <Main
        loaded={loaded}
        company={company}
        user={user}
        companies={companies}
        setCompany={setCompany}
      />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/containers/Main/Main.tsx